/** UI day keys used by the provider calendar availability modal. */
export const PROVIDER_AVAILABILITY_UI_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;
export type ProviderAvailabilityUiDay = (typeof PROVIDER_AVAILABILITY_UI_DAYS)[number];

export interface ProviderAvailabilitySlot {
  start: string;
  end: string;
}

export interface ProviderDayAvailability {
  enabled: boolean;
  slots: ProviderAvailabilitySlot[];
}

export type ProviderWeeklyAvailability = Record<string, ProviderDayAvailability>;

export const DEFAULT_PROVIDER_AVAILABILITY_SLOT: ProviderAvailabilitySlot = {
  start: '9:00 AM',
  end: '6:00 PM',
};

export function getDefaultProviderWeeklyAvailability(): ProviderWeeklyAvailability {
  const out: ProviderWeeklyAvailability = {};
  for (const day of PROVIDER_AVAILABILITY_UI_DAYS) {
    out[day] = {
      enabled: day !== 'Sat' && day !== 'Sun',
      slots: day !== 'Sat' && day !== 'Sun' ? [{ ...DEFAULT_PROVIDER_AVAILABILITY_SLOT }] : [],
    };
  }
  return out;
}
